import { css } from '@emotion/react';
import * as breakpoints from '../../constants/breakpoints';
export default {
    icon: css `
    @media (min-width: ${breakpoints.LG}) {
      top: -1px;
    }
  `,
};
